module.exports = __webpack_public_path__ + "static/media/ulip.e5a5ffe6.mp3";